export default "__VITE_ASSET__3a8b253d__"